import {
  CreateInstallmentsSwitchOrderResponseProto,
  CreateMedDiscountOrderResponseProto,
} from "@noom/noom-contracts/noom_contracts/growth/orders/growth_orders_service";
import { OrderProto } from "@noom/noom-contracts/noom_contracts/billing/bms/orders/orders_service";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MedDowngradeOrderResponse } from "src/utils/api/tiers";
import type {
  MedCancellationIntentEnumProto_Value,
  MedCancellationReasonEnumProto_Value,
} from "@noom/noom-contracts/noom_contracts/growth/shared";

export enum CounterOfferOutcome {
  CANCEL = "cancel",
  EXTEND_TRIAL = "extension_7_days",
  PAUSE_1_MONTH = "extension_30_days",
  PAUSE_3_MONTHS = "extension_90_days",
  PERCENT_DISCOUNT = "percent_discount",
  PAUSE_1_MONTH_DISCOUNTED = "extension_30_days_discounted_19_per_month",
  PAUSE_3_MONTHS_DISCOUNTED = "extension_90_days_discounted_19_per_month",
  APPLY_DISCOUNT = "discounted_19_per_month",
  KEEP_USING_NOOM = "keep_using_noom",
  KEEP_USING_NOOM_MED_TIER = "keep_using_noom_med_tier",
  BILLING_REMINDER = "billing_reminder",
  TRIAL_BILLING_REMINDER = "trial_billing_reminder",
  PREMIUM_DOWNGRADE = "premium_downgrade",
  PREMIUM_TRIAL_DOWNGRADE = "premium_trial_downgrade",
  PREMIUM_DOWNGRADE_DISCOUNT = "premium_downgrade_discount",
  CANCEL_MED = "cancel_med",
  CANCEL_WHOLE_HEALTH = "cancel_whole_health",
  CANCEL_MEMBERSHIP = "cancel_membership",
  MED_DISCOUNT = "med_discount",
  MED_DOWNGRADE = "med_downgrade",
  MED_EXTEND_TRIAL = "med_extend_trial",
  ERROR = "error",
  INVALID_SUBSCRIPTION = "invalid_subscription",
  INSTALLMENTS = "installments",
}

export type CounterOfferState = {
  outcome?: CounterOfferOutcome;
  cancellationOffersRejected: CounterOfferOutcome[];
  cancellationOffersFailed: CounterOfferOutcome[];
  processed: boolean;
  medCancellationIntent?: MedCancellationIntentEnumProto_Value;
  medCancellationReasons?: MedCancellationReasonEnumProto_Value[];
  medFollowUpQuestions?: MedCancellationReasonEnumProto_Value[];
  medDiscountOrder?: CreateMedDiscountOrderResponseProto;
  medDowngradeOrder?: MedDowngradeOrderResponse;
  medTrialExtensionOrder?: OrderProto;
  trialExtensionOrder?: OrderProto;
  counterOfferOrder?: OrderProto;
  percentDiscountOrder?: OrderProto;
  installmentsSwitchOrder?: CreateInstallmentsSwitchOrderResponseProto;
  error?: {
    sourcePage: string;
    reason?: string;
  };
};

const initialState: CounterOfferState = {
  processed: false,
  cancellationOffersRejected: [],
  cancellationOffersFailed: [],
};

const counterOfferSlice = createSlice({
  name: "counterOffer",
  initialState,
  reducers: {
    resetCounterOffer: () => initialState,
    updateCounterOfferOutcome: (
      state,
      action: PayloadAction<CounterOfferOutcome>
    ) => {
      return {
        ...state,
        outcome: action.payload,
        processed: false,
      };
    },
    updateCounterOffer: (
      state,
      action: PayloadAction<Partial<CounterOfferState>>
    ) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const {
  resetCounterOffer,
  updateCounterOfferOutcome,
  updateCounterOffer,
} = counterOfferSlice.actions;

export default counterOfferSlice;
